var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"flex-1"},[_c('PageHeading',[_vm._v(" Training ")]),_c('StepProgress'),_c('section',{staticClass:"p-8 prose"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }